import { Link } from "react-router-dom";
import TopicOne from "../../resource-contents/tick-history-contents/TopicOne";

const TickHistoryContentOne = () => {
  return (
    <>
      <TopicOne />
      <div className="how__work__resource">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="content-left">
                <h2>Your Source for Accurate Historical Market Data</h2>
                <p>
                  The Pips Tick History provides traders and analysts with a
                  transparent view of historical price movements. Access raw
                  tick-by-tick data for multiple instruments to backtest
                  strategies, verify execution accuracy, and enhance trading
                  decisions. With detailed data streams at your fingertips, you
                  can analyze market behavior like never before. Each dataset is
                  sourced from reliable liquidity providers to ensure precision
                  and consistency across all timeframes. Whether you're
                  optimizing an automated system or validating past trades, the
                  clarity of tick-level data allows for deeper insights and more
                  confident decision-making. Designed for both beginners and
                  quantitative professionals, The Pips Tick History empowers you
                  to refine your approach with unmatched accuracy.
                </p>
                <Link
                  className="slide__btn dg__btn"
                  to={process.env.PUBLIC_URL + "/company/contact"}
                >
                  Access Historical Data
                </Link>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
              <div className="thumb-right">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/resources/tick_history/tick_history_1.png"
                  }
                  alt="computer images"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TickHistoryContentOne;
